module.exports = __webpack_public_path__ + "static/media/microgaming-logo.c7856a5f.png";